import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

export const ticketWrapper = style({
  display: "flex",
  flexDirection: "column",
  padding: "0 1rem",
  backgroundColor: colors.hooplaBackground,
  borderRadius: "10px",
  boxShadow: `0 2px 10px ${colors.hooplaShadowColor}`,

  $nest: {
    "&:not(:last-child)": {
      marginBottom: "12px",
    },
  },
});

export const ticket = style(
  {
    display: "flex",
    minHeight: "6rem",
    alignItems: "center",
  },
  media(queries.medium, {
    marginBottom: "2rem",
    paddingBottom: "0.5rem",
    borderBottom: `1px solid ${colors.hooplaBorderColor}`,
  }),
);

export const middle = style(
  {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "1rem 0 1rem",
  },
  media(queries.large, {
    alignItems: "center",
    padding: 0,
    flexDirection: "row",
  }),
);

export const info = style(
  {
    fontSize: "22px",
    fontWeight: 900,
    flex: 1,
    margin: "1rem",
  },
  media(queries.medium, {
    marginTop: "21px",
  }),
);

export const eventInfoDiv = style(
  {
    fontSize: "15px",
    fontWeight: 100,
    marginTop: "1rem",
    display: "table",
    paddingBottom: "0.5rem",
    flexDirection: "column",
  },
  media(queries.medium, {
    flexDirection: "row",
    display: "flex",
  }),
);

export const purchasesTable = style(
  {
    display: "table",
    borderCollapse: "collapse",
    $nest: {
      tr: {
        borderBottom: `1px solid ${colors.hooplaBorderColor}`,
      },
      "& td:not(:first-child)": {
        padding: "10px 5px 10px 0",
        fontSize: "16px",
        textDecoration: "none",
      },
      "tr > th": {
        color: "rgb(0,0,0)",
        textAlign: "left",
        fontWeight: 400,
        paddingBottom: "0.5rem",
      },
    },
  },
  media(queries.medium, {
    display: "table",
    width: "100%",
    marginBottom: "1rem",
    borderCollapse: "collapse",

    $nest: {
      "& th:first-child, & td:first-child": {
        width: "6.5rem",
      },

      "tr > th": {
        color: "rgb(0,0,0)",
        textAlign: "left",
        fontWeight: 400,
        paddingBottom: "0.5rem",
      },
      td: {
        padding: "0.25rem 0 0.5rem 0",
      },
      tr: {
        borderBottom: 0,
      },
    },
  }),
);

export const addToCalendar = style({
  fontSize: "15px",
  color: "rgba(0,0,0,0.7)",
});

export const headerBox = style(
  {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "baseline",
  },
  media(queries.medium, {
    flexDirection: "row",
  }),
);
